import React, { useState } from "react";
import { Link } from "react-router-dom";
import t from "../../lib/lng";
import { cookie } from '@app/app/lib/cookie';

const CookiePopup = ({ close }) => {
	const [popupShown, setPopupShown] = useState(false);

	setTimeout(() => {
		setPopupShown(true);
	}, 2000);

	function onClickBtn() {
		cookie.set('cookie_accepted', 1, '2100', '01', '01', '/', null, null, 'strict');
		close();
	}

	return(
		<div className={'cookie_popup' + (popupShown ? ' go' : '')}>
			<div className="cookie_popup__text">
				{t.cookiePopupText} <Link className="cookie_popup__link" to="/legal/cookie" target="_blank">{t.CookiePolicy.toLowerCase()}</Link>
			</div>
			<div className="cookie_popup_btn" onClick={onClickBtn}>{t.formatString(t.GotIt, <span>&nbsp;</span>)}</div>
		</div>
	);
}

export default CookiePopup;